var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tipo == 0)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDescomprometer()}}},[_c('span',[_c('i',{staticClass:"fa fa-times-circle-o mr-2"}),_vm._v(" Descomprometer\n        ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }